import { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { Navbar } from './Navbar';
import { Footer } from './Footer';
import { ScrollToTop } from '@/app/ScrollToTop';
import { OnboardingModal } from '@/components/modals/OnboardingModal';
import { CompareBar } from '@/components/shared/CompareBar';
import { ErrorBoundary } from '@/components/shared/ErrorBoundary';
import { SkipToContent } from '@/components/shared/SkipToContent';
import { useOnboardingStore } from '@/stores/onboardingStore';

export function RootLayout() {
  const seen = useOnboardingStore((s) => s.seen);
  const start = useOnboardingStore((s) => s.start);
  const { pathname } = useLocation();

  useEffect(() => {
    if (seen) return;
    const id = window.setTimeout(() => start(), 900);
    return () => window.clearTimeout(id);
  }, [seen, start]);

  return (
    <div className="flex min-h-screen flex-col">
      <SkipToContent />
      <ScrollToTop />
      <Navbar />
      <main id="main" tabIndex={-1} className="flex-1 pt-20 outline-none">
        <ErrorBoundary key={pathname}>
          <Outlet />
        </ErrorBoundary>
      </main>
      <Footer />
      <OnboardingModal />
      <CompareBar />
    </div>
  );
}
